import {useAppSelector} from '@/hooks';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import type {SubtitleObject} from '@PosterWhiteboard/items/transcript-item/subtitle/subtitle.types';
import {getCurrentPageTime} from '@Components/poster-editor/poster-editor-reducer';

export const useGetCurrentSubtitleObject = (): SubtitleObject | undefined => {
  const currentPageTime = useAppSelector(getCurrentPageTime);

  const activeTranscriptItem = useGetSelectedTranscriptItem();

  if (!activeTranscriptItem) {
    return undefined;
  }

  return activeTranscriptItem.getSubtitleAtPageTime(currentPageTime)?.toObject();
};
